/* lua.js generated code 0.3.0 */

var CdKeyButton = xClass("CdKeyButton", function () {
    // return cc.CSLoader.createNode("cocos/homeScene_coupon_btn.csb")
    return cc.Sprite.createWithSpriteFrameName("homeScene/coupon_btn.png");
    // return cc.Node.create()
})
CdKeyButton.prototype.ctor = function () {
    let self = this
    self.init()
}
CdKeyButton.prototype.init = function () {
    var self = this
    var btn = UIButton.create(self, true)
    btn.on(UIButtonEvent.Click, handler(self, self.onOpenCdKey))
    // btn.on(UIButtonEvent.LongPress, handler(self, self.longPress))
    self.btn = btn
}
// CdKeyButton.prototype.longPress = function () {
//     // Toast.make("long pressed")
//     let debug_info = document.createElement('div');
//     debug_info.setAttribute('style', 'position: absolute;top: 0;width: 180px;height: 320px;left: 0;');
//     document.getElementsByTagName("body").appendChild(debug_info)
// }
CdKeyButton.prototype.onOpenCdKey = function () {
    var self = this
    // require("clover/panel/SettingPanel").create().popup(true)
    if (self.isBusy){
        return
    }
    self.isBusy = true
    DCAssist.dc4NewIconPanel("redeem")
    CdKeyManager.getInstance().showCdKeyPanel(()=>{
        self.isBusy = false
    })
}


module.exports = CdKeyButton
